//
// populate the value of maintain payments based on the ticked checkboxes
//

var skipSections = (function () {
    'use strict';

    var maintainFullySelector = "input[name='can_maintain_curr_min_monthly_repayment']";
    var maintainPartiallySelector = "input[name='can_maintain_partial_repayment']";

    var statusFieldSelector = "input[name='maintain_payments']";

    function tryPopulateStatusField() {
        var maintainFullyValue = $(`${maintainFullySelector}:checked`).val();
        var maintainPartiallyValue = $(`${maintainPartiallySelector}:checked`).val();

        var result = "";

        if (maintainFullyValue == "Yes") {
            $("input[name='can_maintain_partial_repayment']:checked").parent().removeClass("active");
            $("input[name='can_maintain_partial_repayment']:checked").prop("checked", false);
            $("select[name='period_of_finance_assistance']").val("");

            result = "Yes";
        } else if (maintainPartiallyValue == "Yes") {
            result = "Partial";
        } else if (maintainPartiallyValue == "No") {
            result = "No";
        }

        $(statusFieldSelector).val(result);
    }

    function init() {
        $(document).ready(function () {
            $(`${maintainFullySelector}`).change(tryPopulateStatusField);
            $(`${maintainPartiallySelector}`).change(tryPopulateStatusField);
        });
    }

    if ($(maintainFullySelector).length) {
        init();
    }
})();